import { Space } from 'antd';
import type React from 'react';
import LanguageSwitcher from './LanguageSwitcher';
import Logomark from './Logomark';

/**
 * A bejelentkezés előtti képernyők közös kerete (#109): ugyanaz a kártya,
 * ugyanaz a háttér és ugyanaz a nyelvváltó, mint a `Login` oldalon — hogy az
 * elfelejtett-jelszó és az új-jelszó oldal ne nézzen ki más terméknek.
 *
 * A `Login.tsx` szándékosan nem lett átírva erre: a bejelentkező oldal élő
 * ügyfelek előtt áll, és a #109 hatóköre nem a stílusa.
 */
const AuthCard: React.FC<{ eyebrow: string; children: React.ReactNode }> = ({
  eyebrow,
  children,
}) => (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      background: 'var(--paper)',
      backgroundImage:
        'radial-gradient(circle at 18% 12%, rgba(184, 137, 61, 0.08) 0%, transparent 38%), radial-gradient(circle at 88% 78%, rgba(31, 58, 45, 0.07) 0%, transparent 42%), radial-gradient(circle at 50% 110%, rgba(215, 53, 28, 0.06) 0%, transparent 50%)',
    }}
  >
    <div
      style={{
        width: '100%',
        maxWidth: 420,
        background: 'var(--paper-light)',
        border: '1px solid rgba(26, 22, 18, 0.1)',
        borderRadius: 14,
        padding: '40px 36px',
        boxShadow: '0 30px 60px -30px rgba(26, 22, 18, 0.25)',
      }}
    >
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div style={{ textAlign: 'center' }}>
          <Logomark size={30} />
          <div
            style={{
              marginTop: 18,
              fontFamily: 'var(--font-mono)',
              fontSize: 10,
              letterSpacing: '0.28em',
              textTransform: 'uppercase',
              color: 'var(--ink-faded)',
            }}
          >
            <span
              style={{
                display: 'inline-block',
                width: 6,
                height: 6,
                borderRadius: 999,
                background: 'var(--vermilion)',
                marginRight: 8,
                verticalAlign: 'middle',
              }}
            />
            {eyebrow}
          </div>
        </div>

        {children}

        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 4 }}>
          <LanguageSwitcher />
        </div>
      </Space>
    </div>
  </div>
);

export default AuthCard;
